import angular from 'angular';

export default function AddSupportTicketAttachmentDialogController(
  ssDialogService,
  alerts,
  loaderService,
  supportSharedModelService
) {
  const vm = this;

  vm.file = null;

  vm.handleCloseDialog = _handleCloseDialog;

  vm.handleFileAdd = _handleFileAdd;
  vm.handleSaveAttachment = _handleSaveAttachment;

  _activate();

  /** ***************************************
   * Event Handlers
   */

  // eslint-disable-next-line no-unused-vars
  function _handleFileAdd($files, $file, $newFiles, $duplicateFiles, $invalidFiles, $event) {
    vm.progress = 0;
  }

  function _handleCloseDialog() {
    _closeDialog();
  }

  function _handleSaveAttachment(form) {
    if (form.$valid) {
      loaderService.showViewLoader = true;
      _saveAttachment()
        .then((savedAttachment) => {
          loaderService.showViewLoader = false;
          const items = [];
          items.push(savedAttachment);

          angular.forEach(vm.ticketCopy.attachments, (attachment) => {
            items.push(attachment);
          });

          vm.ticketCopy.attachments = items;

          if (items.length > 0) {
            vm.ticketCopy.hasAttachments = true;
          } else {
            vm.ticketCopy.hasAttachments = false;
          }

          angular.extend(vm.ticket, vm.ticketCopy);
          _closeDialog();
        })
        .catch((err) => {
          alerts.error(err);
        });
    }
  }

  /** ***************************************
   * Private Functions
   */
  function _activate() {
    vm.ticketCopy = angular.copy(vm.ticket);
  }

  function _saveAttachment() {
    if (vm.file) {
      return _uploadAttachment().then((savedAttachment) => {
        alerts.success('Attachment saved successfully.');
        return savedAttachment;
      });
    }
    return Promise.resolve();
  }

  function _uploadAttachment() {
    return supportSharedModelService.createTicketAttachment(vm.file, vm.ticketCopy.id);
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.support.addSupportTicketAttachmentDialog);
  }
}

AddSupportTicketAttachmentDialogController.$inject = [
  'ssDialogService',
  'alerts',
  'loaderService',
  'supportSharedModelService'
];
